import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // Auth state lives entirely in httpOnly cookies, so the browser can't tell
    // up-front whether the user is signed in. Just try /auth/me silently — a
    // 401 simply means no session.
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth callback, AuthCallback handles it
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const signup = async (email, password, name) => {
    const r = await api.post("/auth/signup", { email, password, name });
    setUser(r.data.user);
    return r.data.user;
  };
  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("logout failed", e); }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, checkAuth, signup, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
